import React, { useState } from 'react'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { withRouter } from 'react-router'
import Sticky from 'react-stickynode'
import { connect } from 'react-redux'

import { accountModal, showUpgradeModal, toggleTeamModal, toggleSignUpModal } from '../../actions'
import { PLANS, PLANS_ID } from '../../../constants/plans'
import CTAButton from '../../../components/CTAButton/CTAButton'
import SignUpPage from '../../../Login/SignUpModal'
import { openPricingPopup } from '../../../utils/sendy'
import { resetUserProfile } from '../../actions'
import IntegrationsDropdown from './components/IntegrationsDropdown'
import { onUpgradePlan } from 'utils/general'
import celloService from '../../../services/cello'
import HelpDropdown from './components/HelpDropdown'
import FeaturesDropdown from './components/FeaturesDropdown'
import { addUpgradeReason } from 'utils/general'
import CustomModal from 'components/CustomModal/CustomModal'
import useCheckIsMobileScreen from '../../../hooks/checkMobileScreen'

import styles from './Header.module.css'
import './general.css'

const logout = (history, dispatch) => {
  localStorage.removeItem('token')
  celloService.clearToken()
  localStorage.removeItem('b2bFreeTrialAlertClosed')
  dispatch(resetUserProfile())
  const redirectPath = window.localStorage.getItem('mobile-mode') === 'true' ? '/sign-up' : '/login'
  history.push(redirectPath)
}

export const NavItem = ({ icon, alt, label, href, target, onClick, className }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault() // Prevent default link behavior if onClick is provided
      onClick()
    }
  }

  return (
    <a
      className={styles.contentBoxNav}
      href={onClick ? '#' : href} // Fallback to "#" if onClick is used
      target={target}
      onClick={handleClick}
    >
      <img src={`/assets/icons/${icon}`} alt={alt} className={styles.img} />
      <span className={`${styles.contentText} ${className}`}>{label}</span>
    </a>
  )
}

export const Item = ({ icon, alt, label, href, target, onClick, subtitle, className, iconClassName }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <a className={styles.contentBox} href={onClick ? '#' : href} target={target} onClick={handleClick}>
      <img src={`/assets/icons/${icon}`} alt={alt} className={`${styles.img} ${iconClassName || ''}`} />
      <div>
        <span className={`${styles.contentText} ${className}`}>{label}</span>
        {subtitle && <div className="grey font-small">{subtitle}</div>}
      </div>
    </a>
  )
}

const UpgradeButton = ({ handleOnUpgrade }) => (
  <CTAButton
    className="m-auto font-16"
    label="Upgrade"
    onClick={handleOnUpgrade}
    size="small"
    data-testid="Header-upgrade-button"
  />
)

const getAccountButton = ({ trialAccount, isChildAccount, handleOnUpgrade }) => {
  if (trialAccount) {
    return <UpgradeButton handleOnUpgrade={handleOnUpgrade} />
  } else if (isChildAccount) {
    return null
  } else {
    return null
  }
}

const Header = ({
  dispatch,
  history,
  proMode,
  productId,
  isLoading,
  isChildAccount,
  showUpgradePayModal,
  showDeleteAccountModal,
  showSignUpModal,
  userProfile,
  onUpgrade
}) => {
  const [sticky, setSticky] = useState(false)
  const { isMobile } = useCheckIsMobileScreen()

  const isFreeAccount = !productId

  const handleStateChange = (status) => {
    setSticky(status.status === Sticky.STATUS_FIXED)
  }

  const planLabel = PLANS_ID[productId]?.label

  const onAddTeam = () => {
    if (isFreeAccount) {
      dispatch(toggleTeamModal(true))
    } else if ([PLANS.PRO_U.id, PLANS.PRO_MAX.id].includes(productId)) {
      dispatch(toggleTeamModal(true))
    } else {
      addUpgradeReason('Add Team Members')
      showUpgradePayModal()
    }
  }

  const handleOnUpgrade = () => {
    if (userProfile?.productId) {
      if (userProfile?.teamSize > 0) {
        onUpgradePlan({ planId: PLANS.PRO_U.id, userProfile }, dispatch)
      } else {
        onUpgrade()
      }
    } else {
      dispatch(showUpgradeModal(true))
      openPricingPopup()
    }
  }

  const handleEarnClick = async (event) => {
    /*if (!userProfile) return

    event.preventDefault()
    event.stopPropagation()
    await celloService.initAndOpen(userProfile)*/

    window.open('https://tiiny.host/creators', '_blank')
  }

  return (
    <Sticky enabled={!isMobile} innerClass={sticky ? 'sticky' : ''} onStateChange={handleStateChange} innerZ={999}>
      <CustomModal
        show={showSignUpModal}
        onHide={() => dispatch(toggleSignUpModal(false))}
        centered
        enforceFocus={false}
        mobileCloseButton={false}
      >
        <div className="container p-3 ">
          <SignUpPage />
        </div>
      </CustomModal>
      <Navbar bg="white" expand="lg" collapseOnSelect>
        <Navbar.Brand className="d-l-none d-block" href="/">
          <img className="home-header-logo" src="/assets/logo.png" alt="tiny.host" onClick={() => history.push('/')} />
        </Navbar.Brand>
        <Navbar.Toggle className="ms-3" aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          {proMode && (
            <>
              <Nav className="me-auto" activeKey="/none">
                <HelpDropdown hasAPIAccess={productId === PLANS.API.id} userProfile={userProfile} dispatch={dispatch} />

                <IntegrationsDropdown />

                <FeaturesDropdown />

                <Nav.Item className="d-lg-none d-block">
                  <div className="header-link float-left">
                    <NavItem
                      icon="account.svg"
                      alt="manage"
                      label="Manage Account"
                      target="_blank"
                      onClick={() => dispatch(accountModal(true))}
                    />
                  </div>
                </Nav.Item>

                {isFreeAccount && !isChildAccount && (
                  <Nav.Item className="d-lg-none d-block">
                    <div className="header-link float-left">
                      <NavItem
                        icon="upgrade.svg"
                        alt="manage"
                        label="Upgrade Subscription"
                        target="_blank"
                        onClick={() => {
                          dispatch(showUpgradeModal(true))
                          openPricingPopup()
                        }}
                        className={styles.colorText}
                      />
                    </div>
                  </Nav.Item>
                )}

                {!isChildAccount && (
                  <Nav.Item className="d-lg-none d-block">
                    <div className="header-link float-left">
                      <NavItem icon="team.svg" alt="team" label="My Team" onClick={onAddTeam} />
                    </div>
                  </Nav.Item>
                )}

                <Nav.Item className="d-lg-none d-block">
                  <div
                    className={`header-link float-left celloClass ${styles.celloBadgeContainer}`}
                    onClick={handleEarnClick}
                  >
                    <NavItem icon="coin.svg" alt="referral" label="Refer Friends" subtitle="Earn rewards" />
                    {/* Invisible div for Cello badge positioning - Mobile */}
                    <div className={`celloClass ${styles.celloBadgeMobile}`}></div>
                  </div>
                </Nav.Item>

                {isFreeAccount && (
                  <Nav.Item className="d-lg-none d-block">
                    <div className="header-link float-left">
                      <NavItem
                        icon="delete.svg"
                        alt="delete"
                        label="Delete account"
                        target="_blank"
                        onClick={showDeleteAccountModal}
                      />
                    </div>
                  </Nav.Item>
                )}
                <Nav.Item className="d-lg-none d-block">
                  <div className="header-link float-left">
                    <NavItem
                      icon="logout.svg"
                      alt="logout"
                      label="Sign out"
                      target="_blank"
                      onClick={() => logout(history, dispatch)}
                    />
                  </div>
                </Nav.Item>
              </Nav>

              {/* Account Dropdown */}
              <Nav className="account-tab d-none d-lg-flex">
                <div
                  className={`${styles.addCello} celloClass ${styles.celloBadgeContainer}`}
                  title="Refer Friends & Earn Rewards"
                  onClick={handleEarnClick}
                >
                  <span className={`${styles.imgContent} d-flex align-items-center cursor-pointer px-1 h-24`}>
                    Earn $50
                  </span>
                  <div className={`celloClass ${styles.celloBadgeDesktop}`}></div>
                </div>

                {/* Add Team Button - Desktop */}
                {!isChildAccount && (
                  <div onClick={onAddTeam} data-testid="Header-add-team-button tr-add-team" className={styles.addTeam}>
                    <span className={`${styles.imgContent} d-flex align-items-center cursor-pointer px-1 h-24`}>
                      <img
                        src="/assets/icons/team.svg"
                        alt="team"
                        className={styles.marginRight}
                        height="17"
                        width="17"
                      />
                      Add Team
                    </span>
                  </div>
                )}

                <NavDropdown
                  className={`${styles.accountBtn} p-md-0 m-auto`}
                  title={
                    <span
                      className="d-flex justify-content-between align-items-center px-1 font-16"
                      data-testid={`Header-span-status-${planLabel ? planLabel.toLowerCase() : 'free'}`}
                    >
                      <img
                        src="/assets/icons/account.svg"
                        className="me-2 rounded-circle dropdown-toggle"
                        height={25}
                        width={25}
                        alt="account"
                      />
                      {planLabel ? `${planLabel} plan` : 'Free plan'}
                      <img src={`/assets/icons/vector.svg`} className={styles.img_account} alt="dropdown arrow" />
                    </span>
                  }
                >
                  <div className={styles.menu}>
                    <div className={styles.contentContainer}>
                      <Item
                        icon="account.svg"
                        alt="manage"
                        label="Manage Account"
                        target="_blank"
                        onClick={() => {
                          history.push({ pathname: '/manage/account' })
                          dispatch(accountModal(true))
                        }}
                      />
                      {!isChildAccount && (
                        <Item
                          icon="upgrade.svg"
                          alt="manage"
                          label="Upgrade Subscription"
                          target="_blank"
                          onClick={onUpgrade ?? handleOnUpgrade}
                          className={styles.colorText}
                        />
                      )}
                    </div>

                    {!isChildAccount && (
                      <div className={styles.contentContainer}>
                        <Item icon="team.svg" alt="team" label="Add Team" onClick={onAddTeam} />
                      </div>
                    )}

                    {isFreeAccount && (
                      <div className={styles.contentContainer}>
                        <Item
                          icon="delete.svg"
                          alt="delete"
                          label="Delete account"
                          target="_blank"
                          onClick={showDeleteAccountModal}
                        />
                      </div>
                    )}
                    <div className={styles.contentContainer}>
                      <Item
                        icon="logout.svg"
                        alt="logout"
                        label="Sign out"
                        target="_blank"
                        onClick={() => logout(history, dispatch)}
                      />
                    </div>
                  </div>
                </NavDropdown>
                {!isLoading && (
                  <Nav.Link>
                    {getAccountButton({ trialAccount: isFreeAccount, isChildAccount, handleOnUpgrade })}
                  </Nav.Link>
                )}
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </Navbar>
    </Sticky>
  )
}

const mapDispatchToProps = (dispatch) => ({ dispatch })
const mapStateToProps = (state) => ({
  userProfile: state.manage.userProfile,
  productId: state.manage.userProfile.productId,
  isLoading: !state.manage.userProfile.email,
  isChildAccount: !!state.manage.userProfile?.childAccount,
  email: state.manage.userProfile.email,
  showSignUpModal: state.manage.showSignUpModal
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header))
